module.exports = __webpack_public_path__ + "img/image23.ede838cb.png";